export const sendWhatsapp = (phone: string) => {
  const whatsappUrl = `https://wa.me/${phone}`

  window.open(whatsappUrl, '_blank')
}
